import { useState } from 'react';

const FORM_SUBMIT_URL = 'https://readdy.ai/api/form/d9u37nf8l97n3eas3gh0';

export default function NewsletterCTA() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setStatus('loading');
    setFormError('');

    try {
      const form = e.currentTarget;
      const formData = new FormData(form);
      const honeypot = formData.get('website_alt');
      if (honeypot && String(honeypot).trim() !== '') {
        setStatus('success');
        setEmail('');
        setTimeout(() => setStatus('idle'), 3000);
        return;
      }
      formData.delete('website_alt');

      const response = await fetch(FORM_SUBMIT_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });

      const responseText = await response.text();
      let parsed: Record<string, unknown> | null = null;
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }

      if (response.ok && parsed && (parsed as Record<string, unknown>).code === 'OK') {
        setStatus('success');
        setEmail('');
        setTimeout(() => setStatus('idle'), 5000);
      } else {
        const msg =
          (parsed && typeof (parsed as Record<string, string>).message === 'string'
            ? (parsed as Record<string, string>).message
            : '') ||
          (parsed && (parsed as Record<string, Record<string, string>>).meta && typeof (parsed as Record<string, Record<string, string>>).meta.message === 'string'
            ? (parsed as Record<string, Record<string, string>>).meta.message
            : '') ||
          responseText ||
          '订阅失败，请稍后重试';
        setFormError(msg);
        setStatus('error');
      }
    } catch {
      setFormError('网络错误，请检查您的网络连接后重试');
      setStatus('error');
    }
  };

  return (
    <section id="newsletter" className="py-16 md:py-24 bg-background-100">
      <div className="container-custom max-w-2xl text-center">
        <h2 className="section-title">开启你的探索之旅</h2>
        <p className="section-subtitle">
          订阅欲望之岛通讯，每周获取精选文章、活动信息与内心探索工具。
          前1000名订阅者将获得免费的《欲望地图》电子书。
        </p>

        <form
          id="newsletter-form"
          data-readdy-form
          onSubmit={handleSubmit}
          className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto mt-6"
        >
          <input
            type="text"
            name="website_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
            className="honeypot-field"
          />
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="输入你的邮箱地址"
            required
            className="flex-1 px-5 py-3 rounded-full text-sm bg-background-200 border border-background-300/50 text-foreground-200 placeholder:text-foreground-600 focus:outline-none focus:border-primary-500/50 transition-colors duration-300"
          />
          <button
            type="submit"
            disabled={status === 'loading'}
            className="btn-primary !rounded-full !px-8 !py-3 whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {status === 'loading' ? '订阅中...' : '免费订阅'}
          </button>
        </form>

        {status === 'success' && (
          <p className="mt-4 text-sm text-primary-400 animate-fade-in">
            感谢订阅！请查看你的邮箱确认。
          </p>
        )}
        {status === 'error' && (
          <p className="mt-4 text-sm text-accent-400 animate-fade-in">
            {formError}
          </p>
        )}
      </div>
    </section>
  );
}